// Client half of the recording diagnostic trail (see app/models/recording_event.rb).
//
// The collection client uploads audio straight to S3 and records the filename
// through a separate websocket, so the two halves can fail independently and
// silently.  Every step of a session logs here so a missing file or a missing
// filename can be traced afterwards.
//
// Logging is best effort: it never throws, and it never blocks a session.

let context = {};

// kit_uid / session / sessionn for the session in progress, merged into every
// subsequent event
function set_event_context(o){
    context = { ...context, ...(o || {}) };
    return context;
}

function csrf_token(){
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
}

// name:   short event name, see the list in RecordingEvent
// detail: anything JSON-serialisable, kept as a blob for later reading
// extra:  top level columns -- filename, seq, ok
function log_event(name, detail, extra){
    const body = {
        name,
        kit_uid: context.kit_uid,
        session: context.session,
        sessionn: context.sessionn,
        client_time: Date.now(),
        ...(extra || {}),
        detail: detail === undefined ? null : detail
    };
    console.log('event', name, body);
    try {
        return fetch('/recording_events', {
            method: 'POST',
            // keepalive lets the last events of a session survive the page
            // being torn down, which is exactly when we lose uploads
            keepalive: true,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-Token': csrf_token()
            },
            body: JSON.stringify(body)
        }).catch( (e) => console.error('log_event failed', name, e) );
    }
    catch(e) {
        console.error('log_event failed', name, e);
        return Promise.resolve();
    }
}

export { set_event_context, log_event }
